import { StartPlayingScreen } from '@/screens/index'

export default function () {
  return <StartPlayingScreen />
}
